// Enums from Prisma
export enum CouponType {
  CARD_CREATION = 'CARD_CREATION',
  CARD_RELOAD = 'CARD_RELOAD',
  TRANSACTION = 'TRANSACTION',
  REFERRAL = 'REFERRAL',
}

export enum DiscountType {
  PERCENTAGE = 'PERCENTAGE',
  FIXED = 'FIXED',
}

// Interface for Coupon
export interface Coupon {
  id: number;
  code: string;
  name: string;
  description?: string | null;
  type: CouponType;
  discountType: DiscountType;
  discountValue: number;
  minimumAmount?: number | null;
  maxDiscountAmount?: number | null;
  maxUses?: number | null;
  currentUses: number;
  maxUsesPerUser?: number | null;
  isActive: boolean;
  validFrom: Date | string;
  validUntil?: Date | string | null;
  businessId?: number | null;
  allowedCardTypes?: string | null;
  tierRestrictions?: string | null;
  createdAt: Date | string;
  updatedAt: Date | string;
}

// Interface for UserCoupon
export interface UserCoupon {
  id: number;
  userId: number;
  couponId: number;
  usedCount: number;
  isAssigned: boolean;
  assignedAt: Date | string;
  lastUsedAt?: Date | string | null;
  createdAt: Date | string;
  updatedAt: Date | string;
  coupon: Coupon;
}

// Response interfaces
export interface CouponResponseData {
  success: boolean;
  code: number;
  msg: string;
  data: Coupon;
}

export interface UserCouponsListResponse {
  success: boolean;
  code: number;
  msg: string;
  data: {
    list: UserCoupon[];
    totalRecords: number;
    pageNum: number;
    pageSize: number;
    totalPages: number;
  };
}
